import { learningRegistryAPI } from '@/providers/apis/learning-registry/learning-registry';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'partner-index-form',
    components: {
        'partner-fill-data': () => import('@/components/learing-registry/partner-api-form-data/partner-api-form-data.vue'),
    },
})

export default class PartnerIndexForm extends Vue {

    // ---------------------------------------------------------------
    // Properties

    public actionTypes: any = [
        {
            name: 'POST',
            key: 'post',
        },
        {
            name: 'GET',
            key: 'get',
        },
        {
            name: 'PUT',
            key: 'put',
        },
    ];

    public activeType: any = this.actionTypes[0];

    public actionTabs: any = [
        {
            name: 'Params',
            key: 'query_params',
            description: 'Query Params',
        },
        {
            name: 'Headers',
            key: 'headers',
            description: 'Headers',
        },
        {
            name: 'Body',
            key: 'request_body',
            description: 'JSON Data',
        },
    ];

    public activeTab = this.actionTabs[0];

    public partnerConfig: any = {};

    @Prop()
    public value: any;

    public connectionMsg: string = '';

    @Watch('partnerConfig', {deep: true})
    public onWatchPartnerConfig(value: any) {
        this.$emit('input', value);
    }

    // ---------------------------------------------------------------
    // Actions

    public onSwitchTab(tab: any) {
        this.activeTab = tab;
    }

    public onSelectType(action: any) {
        this.activeType = action;
        this.partnerConfig.method = action.key;
    }

    public onTestConnection() {
        this.testConnection();
    }

    // ---------------------------------------------------------------
    // Hooks

    private created() {
        if (this.value) {
            this.partnerConfig = this.value;
        } else {
            this.partnerConfig.method = this.activeType.key;
            this.partnerConfig[this.activeTab.key] = {};
        }

    }


    // ---------------------------------------------------------------
    // Methods

    private testConnection() {
        learningRegistryAPI.testConnection(this.partnerConfig).then((msg: string) => {
            this.connectionMsg = msg;
        });
    }



}
